
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M9.895 11.515c-2.232 0-4.632-.938-6.948-2.73A18.106 18.106 0 01.127 6.1a.582.582 0 010-.683l.036-.042C.366 5.133 1.379 3.93 2.947 2.73 5.263.938 7.663 0 9.895 0c2.231 0 4.631.938 6.947 2.73a19.962 19.962 0 012.654 2.469c.11.121.174.191.188.196a.582.582 0 010 .682l-.054.063a18.332 18.332 0 01-2.788 2.646c-2.316 1.79-4.716 2.73-6.947 2.73zm8.674-5.757C17.537 4.628 14 1.066 9.895 1.066c-4.105 0-7.642 3.561-8.674 4.692 1.032 1.13 4.569 4.69 8.674 4.69 4.105 0 7.642-3.56 8.674-4.69z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.79 5.758c0 2.175-1.748 3.945-3.895 3.945C7.747 9.703 6 7.933 6 5.758c0-2.176 1.747-3.946 3.895-3.946 2.147 0 3.895 1.77 3.895 3.946zm-1.053 0c0-1.579-1.284-2.88-2.842-2.88S7.053 4.18 7.053 5.759c0 1.578 1.284 2.878 2.842 2.878s2.842-1.3 2.842-2.878z","fill":"#fff"}})])
          )
        }
      }
    